import { Injectable } from '@angular/core'
import { BehaviorSubject, map } from 'rxjs'
import { EventTicketPackageEntity } from 'libs/gb-dashboard/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.models'

@Injectable({
  providedIn: 'root',
})
export class GbEventTicketPackageSelectService {
  private readonly selectedEventTicketPackagesSubject = new BehaviorSubject<EventTicketPackageEntity[]>([])

  readonly selectedEventTicketPackages$ = this.selectedEventTicketPackagesSubject.asObservable()
  readonly selectedEventTicketPackageUuids$ = this.selectedEventTicketPackages$.pipe(
    map((eventTicketPackages) => eventTicketPackages.map((eventTicketPackage) => eventTicketPackage.uuid)),
  )
  readonly selectedEventTicketPackagesCount$ = this.selectedEventTicketPackages$.pipe(
    map((eventTicketPackages) => eventTicketPackages.length),
  )
  readonly selectedEventTicketPackagesHaveActivity$ = this.selectedEventTicketPackages$.pipe(
    map((eventTicketPackages) => eventTicketPackages.some((pkg) => Boolean(pkg.ticket_packages_sold))),
  )

  get selectedEventTicketPackages(): EventTicketPackageEntity[] {
    return this.selectedEventTicketPackagesSubject.value
  }

  selectEventTicketPackage(eventTicketPackage: EventTicketPackageEntity): void {
    if (this.selectedEventTicketPackages.some((selected) => selected.uuid === eventTicketPackage.uuid)) return

    this.setSelectedEventTicketPackages([...this.selectedEventTicketPackages, eventTicketPackage])
  }

  setSelectedEventTicketPackages(eventTicketPackages: EventTicketPackageEntity[]): void {
    const uniqueEventTicketPackages = eventTicketPackages.filter(
      (eventTicketPackage, index, packages) =>
        packages.findIndex((selected) => selected.uuid === eventTicketPackage.uuid) === index,
    )

    this.selectedEventTicketPackagesSubject.next(uniqueEventTicketPackages)
  }

  deselectEventTicketPackage(uuid: string): void {
    this.setSelectedEventTicketPackages(
      this.selectedEventTicketPackages.filter((eventTicketPackage) => eventTicketPackage.uuid !== uuid),
    )
  }

  deselectAllEventTicketPackages(): void {
    this.selectedEventTicketPackagesSubject.next([])
  }
}
